module.exports = __webpack_public_path__ + "static/media/fuel3.72a399be.svg";